






























































































































































































































































































































































































import Vue from "vue";
import { SubscriptionPatch, Subscription } from "@infoland/iprova-api";
import storeHelper from "./../../store/store-helper";
import Clamp from "../generic/Clamp.vue";
import moment, { unitOfTime } from "moment";
import Utils from "@/utils";
import ZenyaDialog from "../dialogs/ZenyaDialog.vue";
import { Task, deleteTeamTaskAsync, updateTeamTaskAsync, ApiPatchTask, UserAssignment, TaskActionLink, loadMyTasksAsync } from "@/tasks";
import PostponeDialog from "./PostponeDialog.vue";
import TeamTask from "@/views/Teams/TeamTask.vue";
import { Member } from "@/teams";
import { RedirectFactory, Redirection } from "./RedirectToActionFactory";

export default Vue.extend({
    name: "TasksListItem",
    props: {
        item: Object as () => Task,
        notifications: Boolean,
        team: Boolean,
        teamMembers: Array as () => Member[],
        isSelected: Boolean
    },
    components: {
        Clamp,
        ZenyaDialog,
        PostponeDialog,
        TeamTask
    },
    watch: {
        expanded(v: boolean) {
            if (v == true) {
                this.markAsRead();
            }
        },
        isSelected(newValue) {
            this.selected = newValue;
        },
        selected(newValue: boolean): void {
            this.$emit("task-selection-changed", this.item.id, newValue);
        }
    },
    data: () => {
        return {
            isBusy: false,
            expanded: false,
            postponeUntilDatePicker: false,
            showTeamTaskDialog: false,
            teamTaskDialogMode: "" as string,
            selected: false as boolean,
            showReassignMenu: false as boolean,
            showActionsMenu: false as boolean
        };
    },
    computed: {
        xsView(): boolean {
            return this.$vuetify.breakpoint.name === "xs";
        },
        mdAndDown(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        },
        isOverdue(): boolean {
            return this.item.deadline_date_time && this.item.deadline_date_time < new Date();
        },
        isModified(): boolean {
            return this.item.last_modified_date_time > this.item.created_date_time;
        },
        subscription(): Subscription {
            const subscriptions = storeHelper.subscriptionsStore.subscriptions;
            if (subscriptions == null) return null;
            const subscription = subscriptions.find(x => x.subscription_id == this.item.subscription_id);
            return subscription;
        },
        hasSubscription(): boolean {
            return !!this.subscription;
        },
        showSubscription(): boolean {
            //find will return undefined if it cannot find the subscription (this happens for example for push messages)
            return this.subscription && this.subscription.show_in_messages_list;
        },
        sortedNotifications(): any {
            let items = [];
            if (this.item.notifications && this.item.notifications.length > 0) {
                let itemsToday = this.itemsInPeriod(moment());
                let itemsYesterday = this.itemsInPeriod(moment().subtract(1, "days"));
                let itemsDayBeforeYesterday = this.itemsInPeriod(moment().subtract(2, "days"));
                let itemsOlder = this.item.notifications.filter(x => ![...itemsToday, ...itemsYesterday, ...itemsDayBeforeYesterday].includes(x));

                if (itemsToday.length > 0) items.push({ dividerText: this.$t("general.time.today").toString(), items: itemsToday });
                if (itemsYesterday.length > 0) items.push({ dividerText: this.$t("general.time.yesterday").toString(), items: itemsYesterday });
                if (itemsDayBeforeYesterday.length > 0)
                    items.push({ dividerText: this.$t("general.time.dayBeforeYesterday").toString(), items: itemsDayBeforeYesterday });
                if (itemsOlder.length > 0) items.push({ dividerText: this.$t("general.time.older").toString(), items: itemsOlder });
            }
            return items;
        }
    },
    methods: {
        ellipsisText: function (value: string, breakpoint: number): string {
            let ellipsisBreakpoint = breakpoint ? breakpoint : 10;

            if (value.length > ellipsisBreakpoint) value = value.substring(0, ellipsisBreakpoint) + "...";

            return value;
        },
        openTeamTaskDialog: function (mode: string): void {
            this.showActionsMenu = false;
            this.teamTaskDialogMode = mode;
            this.showTeamTaskDialog = true;
        },
        getTaskDeadlineDatePickerString: function (): string {
            return this.item.deadline_date_time ? Utils.getDatePickerString(this.item.deadline_date_time) : "";
        },
        toCalendar: function (itemDate: Date): string {
            return Utils.toCalendar(itemDate);
        },
        toggleClamp(e: Event) {
            e.stopPropagation();
            this.expanded = !this.expanded;
        },
        showPostponeDatePicker() {
            this.showActionsMenu = false;
            this.postponeUntilDatePicker = true;
        },
        getRedirectInfo(action: TaskActionLink): { path: string; target: string } {
            const redirectToAction = new RedirectFactory({
                url: action.url,
                router: this.$router,
                subscriptionType: this.item.subscription_type,
                groupId: this.item.group.group_id,
                targetWindow: action.target_window,
                teamID: this.$router.currentRoute.params.teamId
            });
            return (redirectToAction as Redirection).getRedirectInfo();
        },
        goToAction(item: Task): void {
            let actionInfo = this.getRedirectInfo(item.action_links[0]);
            window.open(actionInfo.path, actionInfo.target);
        },
        async updateIsImportantAsync() {
            this.showActionsMenu = false;
            this.isBusy = true;

            const newValue = !this.item.is_important;
            if (this.notifications) await storeHelper.notificationsStore.updateIsImportantNotificationAsync(this.item.id, newValue);
            else await storeHelper.tasksStore.updateIsImportantTaskAsync(this.item.id, newValue);
            this.isBusy = false;

            if (this.team) this.$emit("task-updated");
        },
        async updatePostPonedDate(newPostponedDate: Date) {
            await storeHelper.tasksStore.updatePostponedUntilDateTaskAsync(this.item.id, newPostponedDate);

            if (this.team) this.$emit("task-updated");
        },
        async deleteNotification(itemRead: boolean): Promise<void> {
            this.showActionsMenu = false;
            this.isBusy = true;
            if (this.notifications) {
                await storeHelper.notificationsStore.deleteNotification(this.item.id);
            }
            this.isBusy = false;
        },
        async showInList(show: boolean): Promise<void> {
            this.isBusy = true;

            const subscriptionPatch: SubscriptionPatch = {
                show_in_messages_list: show
            };
            const result = await storeHelper.subscriptionsStore.saveSubscriptionAsync(this.item.subscription_id, subscriptionPatch);

            this.isBusy = false;
        },
        async deleteTeamTaskWithConfirmAsync() {
            this.showActionsMenu = false;
            let confirmTitle: string = this.$t("teams.deleteTeamTaskConfirmTitle") as string;
            let confirmMessage: string = this.$t("teams.deleteTeamTaskConfirmMessage", this.item) as string;
            if (await this.$confirm(confirmTitle, confirmMessage)) {
                await deleteTeamTaskAsync(this.item.id);
                this.$emit("task-deleted");
            }
        },
        async reassignTeamTask(member: Member) {
            let teamTaskPatch: ApiPatchTask = {
                assigned_to_user_id: member ? member.user_id : null
            };
            let result = await updateTeamTaskAsync(this.item.id, teamTaskPatch);

            if (result.success) {
                if (member) {
                    let userAssignment: UserAssignment = {
                        user_name: member.name,
                        user_id: member.user_id
                    };
                    this.$emit("update-assigned-to-user-id", this.item, userAssignment);
                } else {
                    this.$emit("update-assigned-to-user-id", this.item, null);
                }
            }
            this.showReassignMenu = false;
        },
        async readUpdatesOfATask() {
            if (this.item.notifications.length > 0) {
                await storeHelper.notificationsStore.updateReadNotificationsAsync(this.item.notifications, false);
                await storeHelper.tasksStore.updateReadTasksAsync([this.item], true);
            }
        },
        moreClicked() {
            //hack to make showing menu work correctly, because without this hack it sometimes stops responding
            this.showActionsMenu = false;
            this.$nextTick(() => {
                this.showActionsMenu = true;
            });
            this.markAsRead();
        },
        async markAsRead() {
            if (this.notifications) await storeHelper.notificationsStore.updateReadNotificationsAsync([this.item], false);
            else await storeHelper.tasksStore.updateReadTasksAsync([this.item], true);
            this.$emit("update-read");
        },
        dateIsSame(date1: Date, date2: Date, period: unitOfTime.StartOf): boolean {
            return moment(date1).isSame(moment(date2), period);
        },
        itemsInPeriod(itemDate: moment.Moment): Task[] {
            return this.item.notifications.filter(x => this.dateIsSame(x.last_modified_date_time, itemDate.toDate(), "day"));
        },
        fixHyperlinks(text: string): string {
            //workaround for a chrome bug that doesnt open hyperlinks in bodies of text (such as the task description) in a new tab
            const textWithFixedHyperlinks = text.replace(/(<\s*a)([^>]*\/?>)/gi, '$1 target="_blank" $2');
            return textWithFixedHyperlinks;
        }
    }
});
